import { wp_rest_api_nonce } from "./config";
import axios from "axios";

export const AJAX_FILE_UPLOAD = async function(endpointUrl, formData, progress = () => {}) {
    try {

        if ('undefined' === typeof endpointUrl || 'undefined' === typeof formData) {
            throw Error("Undefined function parameters");
        }

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-WP-Nonce': wp_rest_api_nonce
            },
            onUploadProgress: progress
        }

        return await axios.post(endpointUrl, formData, config)
            .then( (response) => {
                    return response;
                } )
            .catch( (error) => {
                    throw error;
                } )

    } catch(err) {
        throw err;
    }
}